import { createBrowserRouter, Navigate } from 'react-router-dom';

import { RequireAuth } from '@/components/auth/RequireAuth';
import { RequireRole } from '@/components/auth/RequireRole';
import { AppLayout } from '@/components/layout/AppLayout';
import { DashboardPage } from '@/pages/DashboardPage';
import { ForbiddenPage } from '@/pages/ForbiddenPage';
import { LoginPage } from '@/pages/LoginPage';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { FEATURES } from '@/config/features';
import { OutpatientPage } from '@/pages/OutpatientPage';
import { ResidentsPage } from '@/pages/ResidentsPage';
import { SettingsPage } from '@/pages/SettingsPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/forbidden', element: <ForbiddenPage /> },
  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'residents', element: <ResidentsPage /> },
      // 외래는 협의 완료 전까지 라우트도 닫는다 (메뉴만 감추면 URL 직접 접근이 열려 있음)
      ...(FEATURES.outpatient ? [{ path: 'outpatient', element: <OutpatientPage /> }] : []),
      {
        path: 'settings',
        element: (
          <RequireRole roles={['ADMIN']}>
            <SettingsPage />
          </RequireRole>
        ),
      },
    ],
  },
  { path: '*', element: <NotFoundPage /> },
]);
